import { ScoutWriteMode } from "generated-graphql/graphql";

/**
 * Oak-side Scout write-mode values. Prefer the generated GraphQL enum so
 * Apollo input types (`SendScoutMessageInput.writeMode`) accept values without
 * widening/casting. Runtime/persistence still uses lowercase strings; the API
 * maps at the resolver boundary.
 */
export { ScoutWriteMode };
export type ScoutWriteModeGql = ScoutWriteMode;

export const SCOUT_WRITE_MODE_GQL = {
  OFF: ScoutWriteMode.Off,
  ASK: ScoutWriteMode.Ask,
  AUTO: ScoutWriteMode.Auto,
} as const satisfies Record<"OFF" | "ASK" | "AUTO", ScoutWriteMode>;

export const SCOUT_WRITE_MODE_OPTIONS: ReadonlyArray<{
  value: ScoutWriteMode;
  label: string;
}> = [
  { value: ScoutWriteMode.Off, label: "Off" },
  { value: ScoutWriteMode.Ask, label: "Ask before applying" },
  { value: ScoutWriteMode.Auto, label: "Apply immediately" },
];

export function isScoutWriteModeGql(value: unknown): value is ScoutWriteMode {
  return (
    value === ScoutWriteMode.Off || value === ScoutWriteMode.Ask || value === ScoutWriteMode.Auto
  );
}

export function nextScoutWriteMode(mode: ScoutWriteMode): ScoutWriteMode {
  if (mode === ScoutWriteMode.Off) {
    return ScoutWriteMode.Ask;
  }
  if (mode === ScoutWriteMode.Ask) {
    return ScoutWriteMode.Auto;
  }
  return ScoutWriteMode.Off;
}
